import React, { useContext } from 'react'
import { List } from 'Lib/List'
import SectionHeader from 'Lib/Text/SectionHeader'
import { LEGAL_HEADER } from 'AccountsConstants/language/account'
import LegalListItem from './LegalListItem'
import { LegalContext } from './context'

const Legal = props => {
  const { legalOpts } = useContext(LegalContext)

  const legalList = (
    <List className="mt-10">
      {legalOpts.map(opt => (
        <LegalListItem legalListInfo={opt} />
      ))}
    </List>
  )

  return (
    <React.Fragment>
      <SectionHeader marginTop="20">{LEGAL_HEADER}</SectionHeader>
      {legalList}
    </React.Fragment>
  )
}

export default Legal
